module.exports = __webpack_public_path__ + "static/media/jersey.7157a2f3.png";